import { useEffect, useState } from 'react';
// icon
import { FaRegCircleCheck } from 'react-icons/fa6';
// animation
import AOS from 'aos';
import 'aos/dist/aos.css';
// data
import { data } from '../../data/HeadeData';
// UI components
import { Button } from '../UI/Button/Button';
import ContactModal from '../UI/Modal/ContactModal/ContactModal';
// style
import style from './header.module.css';

const Header = () => {
  const [modalIsOpen, setModal] = useState(false);

  // animation effect
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handelModal = () => {
    setModal(!modalIsOpen);
    !modalIsOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');
  };

  return (
    <>
      <header className={style.header}>
        <div className={`container ${style.header_container}`}>
          <div className={style.content}>
            <h1 className={style.style} data-aos="fade-right">
              Лазертаг Пейнтбол и Гидробол в Казани
              <br />
              <span>Для взрослых и детей</span>
            </h1>
            <p data-aos="fade-left" data-aos-delay="300">
              <FaRegCircleCheck />
              Незабываемый день рождения, отдых выходного дня и другие праздники
              у нас в клубе
            </p>
            <div
              className={style.pc_button}
              onClick={() => handelModal()}
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <Button text="Записаться" type={true} />
            </div>
            <div
              className={style.mob_button}
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <a href="tel:+78432587427">
                {' '}
                <Button text="+7-843-258-74-27" type={true} />
              </a>
            </div>
          </div>
        </div>
        <div className={style.stock_ticker}>
          <ul className={style.ul}>
            {data.detals.map((item) => (
              <li key={item.id} className={style.li}>
                <span className={style.icon}>{item.icon}</span> {item.text}
              </li>
            ))}
          </ul>
          <ul aria-hidden className={style.ul}>
            {data.detals.map((item) => (
              <li key={item.id} className={style.li}>
                <span className={style.icon}>{item.icon}</span> {item.text}
              </li>
            ))}
          </ul>
        </div>
      </header>
      <ContactModal modalIsOpen={modalIsOpen} handelModal={handelModal} />
    </>
  );
};
export default Header;
